//跳转到分类页面
const toClassify = item => {
    if (item.type === 20) {
        //扎带
        localStorage.removeItem("duanzi");
        localStorage.setItem("protype", JSON.stringify(item.id));
        localStorage.setItem("proName", JSON.stringify(item.name));
    } else if (item.id === 101||item.type===47) {
        //端子类跳
        localStorage.setItem("duanzi", 47);
    } else {
        localStorage.removeItem("duanzi");
        localStorage.removeItem("protype");
        localStorage.setItem("productId", JSON.stringify(item.id));
    }
};

const toRecom = item => {
    if (item.type){
        toClassify(item);
        return 'classify';
    }else {//扎带分类
        localStorage.setItem("groupValue", JSON.stringify(item.value));
        localStorage.setItem("detail_productId", JSON.stringify(item.productId));
        return 'detail';
    }
};
export default {
    toClassify,toRecom
}
